/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    css: css`
        display: flex;
        > div {
            width: 50%;
        }
        ${screen("lte", "xs")} {
            flex-wrap: wrap;
            > div {
                width: 100%;
            }
        }
    `,
};

dateRangeStyles.fromDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-right: 10px;
            ${screen("lte", "xs")} {
                padding-right: 0;
            }
        `,
    },
};

dateRangeStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-left: 10px;
            ${screen("lte", "xs")} {
                padding-left: 0;
                padding-top: 20px;
            }
        `,
    },
};
